import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("core_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const STAGES = ["Prospect", "CMA", "Listed", "Contract", "Closing", "Closed"];

export const KPI_LABELS = {
  calls: "Calls",
  texts: "Texts",
  emails: "Emails",
  doors_knocked: "Doors Knocked",
  showings: "Showings",
  listing_appts: "Listing Appts",
  buyer_appts: "Buyer Appts",
  open_houses: "Open Houses",
  social_posts: "Social Posts",
  notes_handwritten: "Handwritten Notes",
};

// Stable aliases so callers / tests can look up by either testid suffix
export const KPI_KEY_ALIASES = { handwritten_notes: "notes_handwritten" };

export function fmtMoney(n) {
  if (n == null || isNaN(n)) return "$0";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);
}

export function isoMonday(d = new Date()) {
  const x = new Date(d);
  const day = x.getDay();
  const diff = x.getDate() - day + (day === 0 ? -6 : 1);
  x.setDate(diff);
  return x.toISOString().slice(0, 10);
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
